import React, { useState, useEffect } from "react";
// import {
//     Grid,
//     Typography,
//     Button,
//     TextField,
//     MenuItem,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     TablePagination,
// } from "@mui/material";
// import { NavLink } from "react-router-dom";
import { Accordion,AccordionSummary,AccordionDetails,Typography,
	Grid, TableBody, TableCell, TableContainer,FormControl,
	Button, TextField, MenuItem, Table, TableHead, TableRow, Paper, TablePagination,
	Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,Checkbox, FormControlLabel,Select,
    InputLabel, ListItemText,Input,InputAdornment,IconButton
 } from "@mui/material";
// import Layout from "../../components/Wrappers/Layout";
// import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
// import { makeStyles } from "@mui/styles";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import { getriskRuleList } from "../../redux/actions/riskRulesListAction";
import { getUpdateRiskList } from "../../redux/actions/updateRiskRulesAction";
import { getAdminLogout } from "../../redux/actions/adminLogoutAction";

const Logout = (dispatch, history, partnerloginUser) => {

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    sessionStorage.removeItem("persist:root");
    sessionStorage.removeItem("secKey");
    dispatch(getAdminLogout({
        authToken: authToken,
        authentication: {
            partnerId: regenerateTokenRes.data.partnerId || ""
        }
    }))
    partnerloginUser.isAvailable = false
    history.push("/index/login")
}

export default Logout